export default __webpack_public_path__ + "static/media/dropdown.3c87717d.svg";